import { MetalCaratOptions, MetalColorOptions } from "../../utils/predefineTypes.js/constant";

export default {
  /* -------------------------------------------------------------------------- */
  /*                             Category List State                            */
  /* -------------------------------------------------------------------------- */
  loading: false,
  listLoading: false,
  MetalRecords: [],
  total: 0,
  FilteredCount: 0,
  /* -------------------------------------------------------------------------- */
  /*                            Create Category State                           */
  /* -------------------------------------------------------------------------- */
  createLoading: false,
  /* -------------------------------------------------------------------------- */
  /*                             Edit Category State                            */
  /* -------------------------------------------------------------------------- */
  editLoading: false,

  /* -------------------------------------------------------------------------- */
  /*                               Predefine types                              */
  /* -------------------------------------------------------------------------- */
  MetalCaratOptions,
  MetalColorOptions
}
